import script from "./CourseSessionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSessionDialog.vue?vue&type=script&setup=true&lang=js"

import "./CourseSessionDialog.vue?vue&type=style&index=0&id=42fc8852&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fc8852"]])

export default __exports__